const productGroups = [
  'AFG',
  'Spirituosen',
  'Bier',
  'Sekt',
  'Wein',
  'Liqueur / Sirup',
  'Zubehör',
  'Gläser etc.',
  'Säfte',
  'Wein',
];
export function createExampleProductGroups(store: any) {
  const existing = store.peekAll('product-group');
  if (existing.length > 0) {
    return false;
  }
  const models = productGroups.map((pg) => {
    return store.createRecord('product-group', {
      name: pg,
      active: true,
      company: store.peekRecord('company', 1),
      created_by: store.peekRecord('user', 1),
      updated_by: store.peekRecord('user', 1),
    });
  });

  return Promise.all(models.map((model) => model.save()));
}
